import moment from 'moment'

export const YEAR_FILTER_SHORT_NAME = "year"
export const yearDefault = [1960, Number(moment().format("YYYY"))]

const sN = YEAR_FILTER_SHORT_NAME
const yD = yearDefault

export const YEAR_FILTER_CONFIG = {
  short_name: sN,
  default_values: yD,
  is_default: value => testYearDefault(value), //right before clean up
  format_to_api: value => formatYearForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatYearFromURL(value) //
}

export const formatYearFromURL = value => {
  let cleanValue = null
  if (value) {
    if (value instanceof Array) {
      if (value.length === 2) {
        //cast them to numbers
        let minYear = Number(value[0])
        let maxYear = Number(value[1])
        if (!isNaN(minYear) && !isNaN(maxYear)) {
          if (minYear < maxYear) {
            //At somepoint we should round these to match the slider?
            //eh, doesn't matter. we'll do this later. only a problem if some one
            //manually messes this up.
            cleanValue = []
            cleanValue[0] = minYear
            cleanValue[1] = maxYear
          }
        }
      }
    }
  }
  return cleanValue
}

export const buildYearLabel = (currentYears) => {
  let yearLabel = ""

  if (
    currentYears[0] === yearDefault[0] &&
    currentYears[1] !== yearDefault[1]
  ) {
    yearLabel = "pre-" + yearDefault[0] + " - " + currentYears[1]
  }

  if (
    currentYears[0] !== yearDefault[0] &&
    currentYears[1] === yearDefault[1]
  ) {
    yearLabel = currentYears[0] + " - " + yearDefault[1] + "+"
  }

  if (
    currentYears[0] !== yearDefault[0] &&
    currentYears[1] !== yearDefault[1]
  ) {
    yearLabel = currentYears[0] + " - " + currentYears[1]
  }

  if (
    currentYears[0] === yearDefault[0] &&
    currentYears[1] === yearDefault[1]
  ) {
    yearLabel = "All Years"
  }

  return yearLabel
}

export const isYearRangeDefault = value => {
  if (value[0] === yearDefault[0] && value[1] === yearDefault[1]) {
    return true
  } else {
    return false
  }
}
//////FOR API SETTING UP
export const formatYearForAPI = value => {
  if (value) {
    return {
      min_year: value[0],
      max_year: value[1]
    }
  } else {
    return {}
  }
}

export const testYearDefault = value => {
  return isYearRangeDefault(value)
}
